<template>
  <v-label>
    <v-rect :config="tagConfig" />
    <v-text 
      ref="text"
      :config="config"
    />
  </v-label>
</template>

<script>
/*

    USE DrawLabel INSTEAD OF THIS COMPONENT IF DRAWING A FLOATING LABEL

*/
export default {
  name: 'Label',
  props: {
    config: {
      type: Object,
      required: true
    },
    textHeight: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    textWidth: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    scale: {
      type: Number,
      required: true,
    },
    backgroundColor: {
      type: String,
      required: true,
    },
  },
  data () {
    return {}
  },
  computed: {
    tagConfig () {
      const {height, width, rotation} = this.config
      return {
        height: parseFloat(this.textHeight || 0) * this.scale,
        width: parseFloat(this.textWidth || 0),
        offsetX: width / -2 * this.scale + parseFloat(this.textWidth || 0) / 2 + width / 2 * this.scale,
        offsetY: height / -2 * this.scale + parseFloat(this.textHeight || 0) / 2 * this.scale + height / 2 * this.scale,
        fill: this.backgroundColor,
        cornerRadius: 4,
        rotation,
      }
    },
  },
}
</script>